export default function AboutUsPresence() {
    return (
        <>
        <section id="about-Headquarters" className="about-Headquarters">
            <h2>OUR PRESENCE</h2>
                <div className="PRESENCE-img">
                    <img src="assets/images/map.png" className="img-fluid" alt="Responsive image"/>
                </div>
                <div className="PRESENCEBox1 PRESENCEBox-common">
                    <div className="location-icon">
                        <img src="https://www.jindalstainless.com/wp-content/themes/jsl/assets/images/pointer.svg" width="22px"
                            className="svgPointer" title="india" alt="p"/>
                    </div>
                    <div className="PRESENCE-content">
                        <h3>india</h3>
                        <p>(branch office)</p>
			        </div>
		        </div>
                <div className="PRESENCEBox2 PRESENCEBox-common">
                    <div className="location-icon">
                        <img src="https://www.jindalstainless.com/wp-content/themes/jsl/assets/images/pointer.svg" width="22px"
                            className="svgPointer" title="india" alt="p"/>
                    </div>
                    <div className="PRESENCE-content">
                        <h3>dubai</h3>
                        <p>(branch office)</p>
                    </div>
                </div>
                <div className="PRESENCEBox3 PRESENCEBox-common">
                    <div className="location-icon">
                        <img src="https://www.jindalstainless.com/wp-content/themes/jsl/assets/images/pointer.svg" width="22px"
                            className="svgPointer" title="india" alt="p"/>
                    </div>
                    <div className="PRESENCE-content PRESENCE-content-head">
                        <h3>zhenjiang, China</h3>
                        <p>(head office)</p>
                    </div>
                </div>
                <div className="PRESENCEBox4 PRESENCEBox-common">
                    <div className="location-icon">
                        <img src="https://www.jindalstainless.com/wp-content/themes/jsl/assets/images/pointer.svg" width="22px"
                            className="svgPointer" title="india" alt="p"/>
                    </div>
                    <div className="PRESENCE-content">
                        <h3>suzhou</h3>
                        <p>(branch office)</p>
                    </div>
                </div>
                <div className="PRESENCEBox5 PRESENCEBox-common">
                    <div className="location-icon">
                        <img src="https://www.jindalstainless.com/wp-content/themes/jsl/assets/images/pointer.svg" width="22px"
                            className="svgPointer" title="india" alt="p"/>
                    </div>
                    <div className="PRESENCE-content">
                        <h3>hong kong</h3>
                        <p>(branch office)</p>
                    </div>
                </div>
	    </section>
        </>
    );
}